var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturePeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.125 40.25C20.125 40.25 17.25 40.25 17.25 37.375C17.25 34.5 20.125 25.875 31.625 25.875C43.125 25.875 46 34.5 46 37.375C46 40.25 43.125 40.25 43.125 40.25H20.125ZM31.625 23C33.9125 23 36.1063 22.0913 37.7238 20.4738C39.3413 18.8563 40.25 16.6625 40.25 14.375C40.25 12.0875 39.3413 9.89371 37.7238 8.2762C36.1063 6.6587 33.9125 5.75 31.625 5.75C29.3375 5.75 27.1437 6.6587 25.5262 8.2762C23.9087 9.89371 23 12.0875 23 14.375C23 16.6625 23.9087 18.8563 25.5262 20.4738C27.1437 22.0913 29.3375 23 31.625 23ZM14.996 40.25C14.57 39.3524 14.3575 38.3684 14.375 37.375C14.375 33.4794 16.33 29.4688 19.941 26.68C18.1389 26.1235 16.2609 25.8519 14.375 25.875C2.875 25.875 0 34.5 0 37.375C0 40.25 2.875 40.25 2.875 40.25H14.996ZM12.9375 23C14.8437 23 16.6719 22.2427 18.0198 20.8948C19.3677 19.5469 20.125 17.7187 20.125 15.8125C20.125 13.9063 19.3677 12.0781 18.0198 10.7302C16.6719 9.38225 14.8437 8.625 12.9375 8.625C11.0313 8.625 9.20309 9.38225 7.85517 10.7302C6.50725 12.0781 5.75 13.9063 5.75 15.8125C5.75 17.7187 6.50725 19.5469 7.85517 20.8948C9.20309 22.2427 11.0313 23 12.9375 23Z",
    fill: "#1B2A4A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturePeople);
export default __webpack_public_path__ + "static/media/feature-people.649d7d741f246a85e5392908ce6cb709.svg";
export { ForwardRef as ReactComponent };